import { Product } from './Product';

export enum DiscountType {
  PERCENTAGE = "percentage",
  PRICE = "price"
}

export interface Discount {
  id: number;
  productId: number;
  type: DiscountType;
  value: number;
  startTime?: Date | null;
  endTime?: Date | null;
  isLimited: boolean;
  isActive: boolean;
  isDeactivated: boolean;
  discountedPrice: number | null;
  createdAt: Date;
  updatedAt: Date;
  
  product?: Product;
}
